import { fetcher } from "utils";

import { GetDiscountCouponsResponse, IPage } from "typings";

type GetDiscountCoupons = (params: { productId?: number | string; page: IPage }) => Promise<GetDiscountCouponsResponse>;

export const get__discount_coupons: GetDiscountCoupons = params => fetcher.get("/discount_coupons", params);
